import { put, takeEvery } from '@redux-saga/core/effects';
import { matchMqttTopic } from 'store/mqtt/listeners/utils';
import { clipDownloadComplete, clipDownloadFailure, clipDownloadProgress } from 'store/video/clip-download/slice';

type ClipConversionMqttSagaPayload = {
    type: string;
    data: { progress: { percent: number }; url: string; cutRange: { begin: number; end: number }; error: string };
};

function* clipConversionMqttSaga(payload: ClipConversionMqttSagaPayload) {
    const { type, data } = payload;

    const [, , provider, id, , action] = type.split('/');
    const { progress, url, cutRange, error } = data;

    switch (action) {
        case 'progress':
            yield put(
                clipDownloadProgress({
                    id: Number(id),
                    provider,
                    progress: progress.percent,
                    url,
                    cutRange,
                })
            );
            break;
        case 'end':
            yield put(clipDownloadComplete({ provider, id: Number(id), url, cutRange }));
            break;
        case 'error':
            yield put(clipDownloadFailure({ provider, id: Number(id), cutRange, error }));
            break;
        default:
    }
}

export default [takeEvery((action) => matchMqttTopic(action, 'clip', 4), clipConversionMqttSaga)];
